export enum Status {
  FINISHED = 'finished',
  ABANDONED = 'abandoned'
}

export enum Vendor {
  IDSCAN = 'IdScan',
  SUMSUB = 'Sumsub',
  INCODE = 'Incode'
}

export enum JourneyState {
  STARTED = 'STARTED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED'
}

export enum VerificationResult {
  PASS = 'PASS',
  FAIL = 'FAIL'
}
